module.exports = __webpack_public_path__ + "img/Unidad22-2.4730c99f.png";